import { useParams } from "react-router";
import { DocumentBlobCard } from "@/services/backend/filestorage/components/document-blob-card";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";

export function WorkOrderExecutionFilesRoute() {
  const { workOrderId } = useParams();

  return (
    <DocumentBlobCard
      subdomain={GSMServiceKind.RLT}
      documentKind={GSMDocumentKind.WorkOrder}
      documentId={workOrderId!}
    />
  );
}
